<template>
    <div class="row date-filter pad-top">
        <label>По дате прихода</label>
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <DatePicker :language="Storage.language" format="yyyy-MM-dd"
                                v-model="Storage.selectedDateReceiptFrom"></DatePicker>
                </div>
                <div class="col-6 action">
                    <DatePicker :language="Storage.language" format="yyyy-MM-dd"
                                v-model="Storage.selectedDateReceiptTo"></DatePicker>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <button :disabled="disabled" @click="this.reset" class="btn btn-info reset reset-receipt"><i
                            class="fa fa-trash"></i>
                        {{ $t('filters.reset') }}
                    </button>
                </div>
                <div class="col-6 action">
                    <dropdown :disabled="disabled">
                        <template :disabled="disabled" slot="button"><i class="fa fa-clock-o"></i> {{ $t('filters.period') }}</template>
                        <div :disabled="disabled" class="dropdown-menu" slot="dropdown-menu">
                            <a :disabled="disabled" @click="yesterday"
                               class="dropdown-item">{{ $t('filters.yesterday') }}</a>
                            <a :disabled="disabled" @click="week" class="dropdown-item">{{ $t('filters.week') }}</a>
                            <a :disabled="disabled" @click="thisMonth"
                               class="dropdown-item">{{ $t('filters.this_month') }}</a>
                            <a :disabled="disabled" @click="lastMonth"
                               class="dropdown-item">{{ $t('filters.last_month') }}</a>
                        </div>
                    </dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker'
import Storage from '../../api/Storage'
import { dropdown } from 'vue-strap'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  name: 'DateReceipt',
  components: {
    DatePicker,
    dropdown
  },
  data () {
    return {
      Storage: Storage
    }
  },
  methods: {
    yesterday () {
      let date = new Date()
      date.setDate(date.getDate() - 1)
      Storage.selectedDateReceiptTo = Storage.selectedDateReceiptFrom = date
    },
    getMaxDate (y, m) {
      if (m === 1) {
        return y % 4 || (!(y % 100) && y % 400) ? 28 : 29
      }
      return m === 3 || m === 5 || m === 8 || m === 10 ? 30 : 31
    },
    week () {
      let date = new Date()
      date.setDate(date.getDate() - 7)
      Storage.selectedDateReceiptFrom = null
      Storage.selectedDateReceiptTo = null
    },
    thisMonth () {
      let date = new Date()
      date.setDate(1)
      Storage.selectedDateReceiptFrom = date
      Storage.selectedDateReceiptTo = new Date()
    },
    lastMonth () {
      let date = new Date()
      date.setMonth(date.getMonth() - 1)
      date.setDate(1)
      Storage.selectedDateReceiptFrom = date

      date = new Date()
      date.setMonth(date.getMonth() - 1)
      date.setDate(this.getMaxDate(date.getYear(), date.getMonth()))
      Storage.selectedDateReceiptTo = date
    },
    reset () {
      this.week()
    }
  },
  mounted: function () {
    if (Storage.selectedDateReceiptFrom === null) {
      this.reset()
    }
    this.$root.$on('filters_reset_all', () => {
      this.reset()
    })
  }
}
</script>

<style scoped>
    .pad-top{
        padding-top:5px;
        margin-top: -20px;
    }
    .reset-receipt {
        background-color: #0c5480;
    }
    label {
        padding: 0 15px;
        margin-bottom: 0.05rem;
    }
</style>



// WEBPACK FOOTER //
// DateReceipt.vue?e25de1cc